import type { ApiUser } from '#/api/userEnvironment/types/ApiUserEnvironment';

export function isUserOrgOwner(
  user: ApiUser | null | undefined,
  orgId?: string,
): boolean {
  const org =
    user && orgId ? user.orgs?.find((o) => o.id === orgId) : undefined;
  return Boolean(org?.canTakeAdminActions);
}
